import { render, staticRenderFns } from "./listModal.vue?vue&type=template&id=195cfac1&scoped=true"
import script from "./listModal.vue?vue&type=script&lang=js"
export * from "./listModal.vue?vue&type=script&lang=js"
import style0 from "./listModal.vue?vue&type=style&index=0&id=195cfac1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195cfac1",
  null
  
)

export default component.exports